import React, { useMemo } from 'react'
import { sortBy } from 'lodash'
import Dropdown from 'components/Dropdown'
import { ActionLink } from 'modules/Services/Network/subcomponents/AccountsList/subcomponents/ActionLink'
import styles from 'modules/Services/Network/subcomponents/AccountsList/account-list.module.scss'
import { useBreakpoint } from 'utils/hoc/breakpointProvider'
import { actionsMap } from 'modules/Services/hooks/useGetAccountAction'
import { Grid } from 'gu-ui-kit'
import PropTypes from 'prop-types'

const ActionsColumn = ({
  row: {
    original: { extra_actions, extra_info, id, login, auto_replenishment },
  },
  networkType,
  i18n,
}) => {
  const breakpoints = useBreakpoint()
  const map = useMemo(() => actionsMap(breakpoints), [breakpoints])

  const orderedActionsList = sortBy(
    extra_actions.filter((action) => !['deposit', 'refresh', 'history'].includes(action)),
    (action) => map[action]?.order,
  )

  const { toDropdown, toRow } = useMemo(() => {
    const orderedActionsLength = orderedActionsList.length

    return orderedActionsLength > 1
      ? {
          toDropdown: orderedActionsList,
          toRow: [],
        }
      : {
          toDropdown: [],
          toRow: orderedActionsList.includes('auto_replenish') ? [] : orderedActionsList,
        }
  }, [orderedActionsList])

  return (
    <Grid
      gap={16}
      justifyContent={'end'}
      alignItems={'center'}
      wrap={false}
      direction={'row'}
    >
      {toDropdown.length > 0 && (
        <Dropdown wrapItems={true}>
          {toDropdown.reverse().map((action, i) => (
            <ActionLink
              fullWidth={true}
              key={'action-link-' + i}
              className={styles['accounts-list__action-link']}
              action={action}
              login={login}
              id={id}
              type={networkType}
              i18n={i18n}
              auto_replenishment={auto_replenishment}
              hideLabel={false}
              extra_info={extra_info}
            />
          ))}
        </Dropdown>
      )}

      {toRow.map((action, i) => (
        <ActionLink
          hideLabel={true}
          key={'action-link-' + i}
          className={styles['accounts-list__action-link']}
          action={action}
          login={login}
          id={id}
          type={networkType}
          i18n={i18n}
          auto_replenishment={auto_replenishment}
          extra_info={extra_info}
        />
      ))}
    </Grid>
  )
}

export default ActionsColumn

ActionsColumn.propTypes = {
  row: PropTypes.object.isRequired,
  networkType: PropTypes.string.isRequired,
  i18n: PropTypes.string.isRequired,
}
